/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { HttpHeaders }                                       from '@angular/common/http';

import { Observable }                                        from 'rxjs';

import { EsercenteProfiloCreationForm } from '../model/models';
import { EsercenteProfiloListFilter } from '../model/models';
import { EsercenteProfiloSchedaDTO } from '../model/models';
import { EsercenteProfiloUpdateForm } from '../model/models';
import { ExceptionResponseDTO } from '../model/models';
import { GenericResponseDTO } from '../model/models';
import { GetProfiloServizio409Response } from '../model/models';
import { GetProfiloServizio422Response } from '../model/models';
import { Pageable } from '../model/models';
import { PagedModelEsercentePraticaBackofficeRowDTO } from '../model/models';
import { PagedModelEsercenteProfiloRowDTO } from '../model/models';


import { Configuration }                                     from '../configuration';


export interface CreaProfiloEsercenteBackofficeRequestParams {
    esercenteProfiloCreationForm: EsercenteProfiloCreationForm;
}

export interface GetProfiloEsercenteBackofficeRequestParams {
    profiloId: string;
}

export interface ListPraticheProfiloEsercenteBackofficeRequestParams {
    profiloId: string;
    pageable: Pageable;
}

export interface ListProfiliEsercenteBackofficeRequestParams {
    filter: EsercenteProfiloListFilter;
    pageable: Pageable;
}

export interface ReinviaAttivazioneProfiloEsercenteBackofficeRequestParams {
    profiloId: string;
}

export interface UpdateProfiloEsercenteBackofficeRequestParams {
    profiloId: string;
    esercenteProfiloUpdateForm: EsercenteProfiloUpdateForm;
}


export interface EsercentiSchedaServiceInterface {
    defaultHeaders: HttpHeaders;
    configuration: Configuration;

    /**
     * Crea un esercente con email di attivazione.
     * Crea utente ESERCENTE e profilo; l\&#39;esercente riceve l\&#39;email di attivazione (testo \&#39;creato da un operatore\&#39;). OP_COMUNE: comune_riferimento_id obbligatorio e tra i suoi (422); SUPERADMIN: facoltativo. P.IVA gia\&#39; registrata: 400 esercente_partita_iva_gia_registrata (senza dati dell\&#39;esistente); email gia\&#39; registrata: 400.
     * @endpoint post /api/v1/gestione/esercenti/profili
* @param requestParameters
     */
    creaProfiloEsercenteBackoffice(requestParameters: CreaProfiloEsercenteBackofficeRequestParams, extraHttpRequestParams?: any): Observable<EsercenteProfiloSchedaDTO>;

    /**
     * Scheda di un esercente.
     * Dati d\&#39;impresa, email, stato account, comune di riferimento, conteggi di negozi, cassieri e domande (queste ultime solo su bandi visibili al chiamante) e version per il PUT. 404 se inesistente o fuori perimetro.
     * @endpoint get /api/v1/gestione/esercenti/profili/{profilo_id}
* @param requestParameters
     */
    getProfiloEsercenteBackoffice(requestParameters: GetProfiloEsercenteBackofficeRequestParams, extraHttpRequestParams?: any): Observable<EsercenteProfiloSchedaDTO>;

    /**
     * Domande di un esercente sui bandi visibili al chiamante.
     * Paginate, piu\&#39; recenti prima (il sort e\&#39; ignorato). OP_COMUNE: solo i bandi dei suoi comuni. 404 se l\&#39;esercente e\&#39; fuori perimetro.
     * @endpoint get /api/v1/gestione/esercenti/profili/{profilo_id}/pratiche
* @param requestParameters
     */
    listPraticheProfiloEsercenteBackoffice(requestParameters: ListPraticheProfiloEsercenteBackofficeRequestParams, extraHttpRequestParams?: any): Observable<PagedModelEsercentePraticaBackofficeRowDTO>;

    /**
     * Lista paginata degli esercenti nel proprio perimetro.
     * SUPERADMIN: tutti. OP_COMUNE: esercenti con comune di riferimento tra i suoi comuni o con almeno una domanda su un bando di un suo comune. Filtri: q (ragione sociale, P.IVA, email), partita_iva, comune_riferimento_id, stato. numero_domande conta solo le domande su bandi visibili al chiamante. Sort ammessi: ragione_sociale (default), partita_iva, email.
     * @endpoint get /api/v1/gestione/esercenti/profili
* @param requestParameters
     */
    listProfiliEsercenteBackoffice(requestParameters: ListProfiliEsercenteBackofficeRequestParams, extraHttpRequestParams?: any): Observable<PagedModelEsercenteProfiloRowDTO>;

    /**
     * Reinvia l\&#39;email di attivazione a un esercente.
     * Solo se l\&#39;account non e\&#39; ancora attivato (invito in attesa): account bloccato dall\&#39;amministrazione, gia\&#39; attivo o sospeso → 422. Il token dell\&#39;invito e\&#39; riusato. Nessun link manuale.
     * @endpoint post /api/v1/gestione/esercenti/profili/{profilo_id}/reinvia-attivazione
* @param requestParameters
     */
    reinviaAttivazioneProfiloEsercenteBackoffice(requestParameters: ReinviaAttivazioneProfiloEsercenteBackofficeRequestParams, extraHttpRequestParams?: any): Observable<GenericResponseDTO>;

    /**
     * Modifica i dati di un esercente.
     * PUT-replace dei dati d\&#39;impresa (stesse regole del self-service, P.IVA inclusa) e del comune di riferimento, con optimistic lock (version stale: 409). SUPERADMIN: comune libero e annullabile. OP_COMUNE: solo se il comune di riferimento dell\&#39;esercente e\&#39; uno dei suoi (altrimenti 403 esercente_dati_non_modificabili; la scheda espone puo_modificare_dati), sceglie solo tra i suoi comuni e non lo annulla (422). P.IVA in collisione: 400.
     * @endpoint put /api/v1/gestione/esercenti/profili/{profilo_id}
* @param requestParameters
     */
    updateProfiloEsercenteBackoffice(requestParameters: UpdateProfiloEsercenteBackofficeRequestParams, extraHttpRequestParams?: any): Observable<EsercenteProfiloSchedaDTO>;

}
